import React from 'react';
import { useTranslation } from 'react-i18next';

interface BreadcrumbProps {
  items: { label: string; onClick?: () => void }[];
  className?: string;
}

/** Hide non-clickable current page crumb until product wants it back. */
const SHOW_CURRENT_PAGE = false;

/**
 * Circus Daily breadcrumb — Figma 10203:49730
 * Surface bar, top/bottom border; parent link underlined white CTA-sm.
 */
const Breadcrumb: React.FC<BreadcrumbProps> = ({ items, className = '' }) => {
  const { t } = useTranslation();
  const visibleItems = SHOW_CURRENT_PAGE ? items : items.filter(item => item.onClick);

  if (visibleItems.length === 0) {
    return null;
  }

  return (
    <nav
      className={`flex w-full min-w-0 items-center gap-2 bg-surface px-6 py-4 ${className}`}
      aria-label={t('a11y.breadcrumb')}
      data-test-id="cd-breadcrumb"
    >
      {visibleItems.map((item, index) => (
        <React.Fragment key={`${item.label}-${index}`}>
          {index > 0 && (
            <span className="shrink-0 font-sans text-cta-sm text-muted-foreground">/</span>
          )}
          {item.onClick ? (
            <button
              type="button"
              onClick={item.onClick}
              className="shrink-0 truncate font-sans text-cta-sm capitalize text-white underline decoration-solid decoration-from-font underline-offset-auto"
            >
              {item.label}
            </button>
          ) : (
            <span className="min-w-0 truncate font-sans text-cta-sm font-semibold capitalize text-white">
              {item.label}
            </span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumb;
